import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../services/api.js';

const AuthContext = createContext({ usuario: null, carregando: true, recarregar: async () => {} });

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const recarregar = useCallback(async () => {
    setCarregando(true);
    try {
      const u = await api.me();
      setUsuario(u);
    } catch (err) {
      if (err.status === 401) {
        try {
          await api.authRefresh();
          const u = await api.me();
          setUsuario(u);
        } catch {
          setUsuario(null);
        }
      } else {
        setUsuario(null);
      }
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    recarregar();
  }, [recarregar]);

  return (
    <AuthContext.Provider value={{ usuario, carregando, recarregar }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
